<template>
  <div class="input-with-info wds-input-group">
    <div class="tw-flex tw-items-center tw-justify-between">
      <label ref="inputLabel" class="tw-text-base tw-mb-0">{{ label }}</label>
      <WdsButtonGhost secondary type="button" @click="showInfo = !showInfo">
        {{ infoTitle }}
      </WdsButtonGhost>
    </div>
    <InfoBox class="tw-my-2" :display="showInfo">
      <slot name="info-text">{{ infoText }}</slot>
    </InfoBox>
    <div ref="wrapper" class="tw-mt-1">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { WdsButtonGhost } from '@worksome/wds-components'
import { defineProps, onBeforeUnmount, onMounted, ref } from 'vue'
import InfoBox from '@/components/InfoBox.vue'

defineProps({
  infoTitle: {
    type: String,
    required: true,
  },
  infoText: {
    type: String,
    required: false,
    default: () => '',
  },
  label: {
    type: String,
    required: true,
  },
})

const inputLabel = ref(null)
const wrapper = ref(null)
const showInfo = ref(false)

function onClickLabel() {
  const $input = wrapper.value?.querySelector('button, input, textarea')
  if ($input === null) {
    return
  }
  $input.focus()
}

onMounted(() => {
  inputLabel.value?.addEventListener('click', onClickLabel)
})

onBeforeUnmount(() => {
  inputLabel.value?.removeEventListener('click', onClickLabel)
})
</script>
